import { NavLink } from 'react-router'
import { FiArrowRight } from 'react-icons/fi'
import { Container, Reveal, RevealGroup, HoverText, Counter } from '@/components/common'
import { ROUTES } from '@/constants/routes'
import { stats } from '@/constants/impact'

export const Impact = () => {
  return (
    <section className="bg-ibon-dark py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-white sm:text-5xl lg:text-6xl">
              Creating <span className="text-white/40">Measurable Change</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-8 text-lg leading-relaxed text-white/70">
              IBON World measures success by the opportunities created, the people reached, and the
              partnerships built through its programmes and initiatives. From entrepreneurship
              support and leadership development to cultural exchange and humanitarian advocacy, our
              work is designed to produce practical outcomes that strengthen individuals and
              communities.
            </p>
          </Reveal>
        </div>

        {/* Counters */}
        <RevealGroup className="mt-16 grid grid-cols-2 gap-x-6 gap-y-12 lg:grid-cols-3" step={90}>
          {stats.map((stat) => (
            <div key={stat.label} className="border-l-2 border-ibon-sky pl-5">
              <div className="text-5xl font-bold tracking-tight text-ibon-sky sm:text-6xl">
                <Counter value={stat.value} suffix={stat.suffix} />
              </div>
              <p className="mt-3 text-sm font-medium uppercase tracking-wide text-white/60">
                {stat.label}
              </p>
            </div>
          ))}
        </RevealGroup>

        {/* Testimonial */}
        <Reveal variant="up" delay={120} className="mt-16">
          <figure className="border-t border-white/15 pt-12">
            <blockquote className="max-w-4xl text-2xl font-medium leading-relaxed text-white sm:text-3xl">
              &ldquo;IBON World helped me turn an idea into a realistic plan. Through mentorship and
              networking opportunities, I gained the confidence and support needed to pursue my
              goals.&rdquo;
            </blockquote>
            <figcaption className="mt-6 text-sm font-semibold uppercase tracking-[0.2em] text-white/70">
              Programme Participant
            </figcaption>
          </figure>
        </Reveal>

        <Reveal variant="up" delay={160}>
          <NavLink
            to={ROUTES.IMPACT}
            className="group mt-10 inline-flex items-center gap-2 rounded-full bg-ibon-sky px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-ibon-dark transition-colors hover:bg-[#6fcdef]"
          >
            <HoverText text="View Our Impact Stories" />
            <FiArrowRight
              className="transition-transform duration-300 group-hover:translate-x-1"
              size={15}
            />
          </NavLink>
        </Reveal>
      </Container>
    </section>
  )
}
